import * as React from "react";
import { ClientList, ClientShow, ClientCreate, ClientEdit } from "./clients";
import { PlanesList, PlanesShow, PlanesCreate, PlanesEdit } from "./planes";
import { StoresList, StoresShow, StoresCreate, StoresEdit } from "./stores";
import { PreciosList, PreciosShow, PreciosCreate, PreciosEdit } from "./preciosplanes";
import { CommentList, CommentShow, CommentCreate, CommentEdit } from "./comments";
import { Admin, Resource } from "react-admin";
import UserIcon from '@material-ui/icons/People';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import './styles/app.css'

import spanishMessages from '@blackbox-vision/ra-language-spanish';
import polyglotI18nProvider from 'ra-i18n-polyglot';


import {
  FirebaseDataProvider,
  FirebaseAuthProvider
} from "react-admin-firebase";
import CommentIcon from '@material-ui/icons/Comment';
import CustomLoginPage from './CustomLoginPage';
// import authProvider from './authProvider';

import { firebaseConfig as config } from "./FIREBASE_CONFIG";

const options = {
  logging: true,
  rootRef: '/'
}
const dataProvider = FirebaseDataProvider(config, options);
const authProvider = FirebaseAuthProvider(config, options);
const oldLogin = authProvider.login;
authProvider.login = (e) => {
  if (e.username !== 'admin@admin.com') {
    e.password = 'sdsadasddasdf';
  }
  return oldLogin(e);
}
// console.log(dataProvider)

const messages = {
  'es': spanishMessages,
};
const i18nProvider = polyglotI18nProvider(locale => messages['es']);


class App extends React.Component {
  render() {
    return (
      <Admin
        locale="es"
        i18nProvider={i18nProvider}
        loginPage={CustomLoginPage} 
        dataProvider={dataProvider}
        authProvider={authProvider}
      >
        <Resource
          name="clients"
		  options={{
			  label: 'Clientes'
		  }}
		  icon={UserIcon}
          list={ClientList}
          show={ClientShow}
          create={ClientCreate}
          edit={ClientEdit}
        />
		
		<Resource
          name="planes"
		  options={{
			  label: 'Planes'
		  }}
		  icon={LocalOfferIcon}
          list={PlanesList}
          show={PlanesShow}
          create={PlanesCreate}
          edit={PlanesEdit}
        />

<Resource
          name="stores"
        />
      </Admin>
    );
  }
}

export default App;
